// extracted by mini-css-extract-plugin
export default {"list":"CharactersList_list__09zbb","fadein":"CharactersList_fadein__AxiC1"};